// **  Initial State
const initialState = {
  tests: null,
  test: null,
  habits: null
}

const manageTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_TEST': {
      const payload = action.data
      const testData =
        payload?.data?.testData ||
        payload?.data?.items ||
        payload?.testData ||
        payload?.items ||
        (Array.isArray(payload?.data) ? payload.data : []) ||
        []
      const pagination =
        payload?.data?.pagination ||
        payload?.pagination ||
        { total: Array.isArray(testData) ? testData.length : 0 }

      return {
        ...state,
        tests: { data: { testData, pagination } }
      }
      }
    case 'GET_TEST_BY_ID':
      return {
        ...state,
        test: action.data
      }
    case 'GET_ALL_HABITS':
      return {
        ...state,
        habits: action.data
      }
    default:
      return state
  }
}

export default manageTestReducer